import React from "react";
import { StyledHeader, StyledRow, StyledTable } from "styles/components/Table.styles";
import useMRFTranslation from "mrf/utils/useMRFTranslation";
import AccordionRow from "mrf/view/AccordionRow";

function AccordionTable({
    contentList,
    contentFields,
    accordionContentFields,
    accordionContentsKey,
    displayAccordionTitle = "Show contents",
    displayAccordionTooltip = "Show contents"
}) {
    const t = useMRFTranslation();

    return <>
        <StyledTable>
            <thead>
                <StyledRow>
                    {contentFields.map((field, idx) => (
                        <StyledHeader>
                            {t(field.name)}
                        </StyledHeader>
                    ))}
                    <StyledHeader>
                        {t(displayAccordionTitle)}
                    </StyledHeader>
                </StyledRow>
            </thead>
            <tbody>
                {contentList?.map(content => (
                    <AccordionRow
                        rowContent={content}
                        rowContentFields={contentFields}
                        accordionContentFields={accordionContentFields}
                        accordionContents={content?.[accordionContentsKey] ?? []}
                        displayAccordionTooltip={displayAccordionTooltip}
                    />
                ))}
            </tbody>
        </StyledTable>
    </>
}

export default AccordionTable;